// Позволяет забрать из стора список по имени
export const selectCurrentList = (state, type) => {
  return state.lists[type]
}
